module.exports = __webpack_public_path__ + "img/logo-text-inverse.c076c7d2.svg";